import React, {Component} from 'react';

import Header from '../decoration/header';
import Footer from '../footer/footer';

import './ourPartners.css';

class OurPartners extends Component {
	render() {
		return (
			<div>
				<Header/>
				<div id='banner'>OUR PARTNERS</div>
				<div id="ourPartnersContentImgDiv">
					<img id="ourPartnersContentImg" alt="ourPartnersContentImg" />
				</div>
				<h3 id="ourPartnersContentTitle"><b>the BORIS 炫冶</b></h3>
				<hr id="firstHr" />
				<div id="ourPartnersContent">
					<div>電話: 4009989946, 020-3216461</div>
					<div>郵箱: service@theborisxy.com</div>
					<div>網站: www.theborisy.com</div>
					<div>地址: 中國廣州市天河區天河路383號太古匯MU07</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default OurPartners;



// WEBPACK FOOTER //
// ./src/components/ourPartners/ourPartners.js